import { Component, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatFormField, MatInput, MatSuffix } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-party-column-filter',
  imports: [FormsModule, MatFormField, ReactiveFormsModule, MatInput, MatIconButton, MatIcon, MatSuffix],
  templateUrl: './party-column-filter.component.html',
  styleUrl: './party-column-filter.component.scss'
})
export class PartyColumnFilterComponent {
  @HostListener('document:click', ['$event'])
  onGlobalClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.filterOpened = false;
    }
  }
  @Output() filterApplied = new EventEmitter<string | null>();
  filterOpened = false;
  value = '';

  private elementRef = inject(ElementRef);

  clear() {
    this.value = '';
    this.filterApplied.emit(null);
  }

  search() {
    this.filterApplied.emit(this.value);
  }

  toggleFilter(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.filterOpened = !this.filterOpened;
  }
}
